<script setup lang="ts">
import { useUserStore } from "@/utils/UserStore";
import { useUpdateBlocker } from "@/composables/useDeferredAppUpdate";

const userStore = useUserStore();
const { logoutUser, logoutForInactivity, stayLoggedIn } = userStore
const { showInactivityPrompt, showInactivityLoggedOutNotice } = storeToRefs(userStore);

const logoutGraceCountdown = ref(60);
let countdownInterval: any = undefined;

const shouldBlockAppUpdate = computed(() => showInactivityPrompt.value || showInactivityLoggedOutNotice.value );

useUpdateBlocker(
  "inactivity-dialogs",
  shouldBlockAppUpdate,
  "Close active security dialogs before updating"
);

watch(showInactivityPrompt, val => {
  if(val) {
    logoutGraceCountdown.value = 60;
    countdownInterval = setInterval(() => {
      logoutGraceCountdown.value--;
      if(logoutGraceCountdown.value <= 0) {
        clearInterval(countdownInterval);
        logoutForInactivity();
      }
    }, 1000);
  } else {
    clearInterval(countdownInterval);
    logoutGraceCountdown.value = 60;
  }
})
</script>
<template>
  <v-dialog
    v-model="showInactivityPrompt"
    persistent
    no-click-animation
    max-width="600"
  >
    <v-card>
      <v-card-text>
        For your security, your session will end in {{ logoutGraceCountdown }} seconds due to inactivity.
      </v-card-text>
      <v-card-actions>
        <v-btn variant="flat" @click="stayLoggedIn">Stay Logged In</v-btn>
        <v-btn variant="flat" color="secondary" @click="logoutUser">Logout</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
